import { IDependency } from "./Dependency";
import { IReportingProgressUpdateWithDeliveryDates, ReportingProgressUpdateWithDeliveryDates } from "./ReportingProgressUpdate";

export interface IDependencyUpdate extends IReportingProgressUpdateWithDeliveryDates {
    DependencyID: number | null;
    Dependency?: IDependency;
}

export class DependencyUpdate extends ReportingProgressUpdateWithDeliveryDates implements IDependencyUpdate {
    public DependencyID: number  | null = null;

    constructor(dependencyId: number, period?: Date) {
        super(period);
        this.DependencyID = dependencyId;
    }
}